import React from 'react';
import Image from 'components/AppImage';

const PublicHeader = () => {
  return (
    <header className="public-header" role="banner">
      <div className="public-header-container">
        <div className="public-header-logo">
          <a href="/">
            <div className="public-header-brand">
              <Image
                src="/images/500.500_logo_Khejalatiam_removebg.png"
                className="bg-white"
              />
            </div>
          </a>
          <a href="/">
            <h1 className="public-header-title">خجالتی‌ام...</h1>
          </a>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
